exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-testimonials{background-image:-webkit-linear-gradient(rgba(0,0,0,.8),rgba(0,0,0,.8)),url(" + require("../../assets/resources/img/back-customers.jpg") + ");background-image:linear-gradient(rgba(0,0,0,.8),rgba(0,0,0,.8)),url(" + require("../../assets/resources/img/back-customers.jpg") + ");background-size:cover;color:#fff;background-attachment:fixed}blockquote{padding:2%;font-style:italic;line-height:145%;position:relative;text-align:left;margin-top:40px}blockquote:before{content:\"\\201C\";font-size:5rem;display:block;position:absolute;top:-5px;left:-5px}cite{font-size:.9rem;margin-top:25px;display:block}cite img{height:45px;border-radius:50%;margin-right:10px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-fc131a92","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/Testimonials.vue
// module id = 52
// module chunks = 0